// import axios from "axios";
import axios from 'axios';
import { URLS } from "./URL";

// src/services/api.js


// Create axios instance with default config
const apiClient = axios.create({
    baseURL: URLS.API_BASE_URL, // Replace with your API URL
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('JWToken');
        if (token) {
            config.headers["x-auth-token"] = token; // Change Authorization to x-auth-token
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            // Handle unauthorized access - redirect to login
            localStorage.removeItem('JWToken');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

const api = {

    // Auth endpoints
    login: (url, credentials, config) => apiClient.post(url, credentials, config),


    // CRUD endpoints
    get: (url) => apiClient.get(url),
    post: (url, data, config) => apiClient.post(url, data, config),
    put: (url, data, config) => apiClient.put(url, data, config),
    delete: (url, config) => apiClient.delete(url, config),

    // File upload endpoint
    upload: (url, formData, config = {}) => {
        const uploadConfig = {
            ...config,
            headers: {
                ...config.headers,
                'Content-Type': 'multipart/form-data',
            },
        };
        return apiClient.post(url, formData, uploadConfig);
    },

};

export default api;